import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { c as n, I as y } from "./Section-DOeCOW54.js";
import g, { useRef as N, useState as E, useImperativeHandle as q, useEffect as C, forwardRef as z } from "react";
import { u as k, T as d } from "./useMediaQuery-BZAMobKw.js";
const f = {
  "form-tooltip": "elo-form-tooltip",
  "form-tooltip__tooltip": "elo-form-tooltip__tooltip",
  "form-tooltip__tooltip--visible": "elo-form-tooltip__tooltip--visible",
  "form-tooltip__tooltip--exit": "elo-form-tooltip__tooltip--exit",
  "form-tooltip__icon": "elo-form-tooltip__icon"
}, H = g.forwardRef(
  ({ title: u, children: i, ..._ }, r) => {
    const t = N(null), [c, a] = E(!1), h = n(
      f["form-tooltip__tooltip"],
      {
        [f["form-tooltip__tooltip--visible"]]: c,
        [f["form-tooltip__tooltip--exit"]]: !c
      }
    ), b = k("(max-width: 1023px)");
    q(r, () => t.current);
    const p = (o) => {
      o.key === "Enter" ? a((v) => !v) : o.key === "Escape" && a(!1);
    }, x = (o) => {
      o.preventDefault(), o.stopPropagation(), b && a((v) => !v);
    }, m = () => {
      t.current && !t.current.contains(document.activeElement) && !b && a(!1);
    };
    return C(() => {
      const o = t.current;
      return o == null || o.addEventListener("blur", m), () => {
        o == null || o.removeEventListener("blur", m);
      };
    }, []), /* @__PURE__ */ s(
      "div",
      {
        ref: t,
        ..._,
        className: n(f["form-tooltip"], _.className),
        onMouseEnter: () => a(!0),
        onMouseLeave: () => a(!1),
        onClick: x,
        onKeyDown: p,
        tabIndex: 0,
        children: [
          /* @__PURE__ */ e(
            O,
            {
              title: u,
              className: h,
              "aria-expanded": c,
              role: "region",
              id: "form-tooltip__tooltip",
              children: i
            }
          ),
          /* @__PURE__ */ e(
            y,
            {
              name: "Help",
              height: "24px",
              width: "24px",
              className: f["form-tooltip__icon"],
              "aria-controls": "form-tooltip__tooltip"
            }
          )
        ]
      }
    );
  }
), I = "elo-input", M = "elo-input__label", R = "elo-input__field", D = "elo-input__helper", L = "elo-input__error", j = "elo-input__wrapper", l = {
  input: I,
  "input-calculator": "elo-input-calculator",
  input__label: M,
  "input-calculator__label": "elo-input-calculator__label",
  "input__label--high": "elo-input__label--high",
  "input-calculator__label--high": "elo-input-calculator__label--high",
  "input__label--low": "elo-input__label--low",
  "input-calculator__label--low": "elo-input-calculator__label--low",
  "input__label--required": "elo-input__label--required",
  "input-calculator__label--required": "elo-input-calculator__label--required",
  input__field: R,
  "input-calculator__field": "elo-input-calculator__field",
  input__helper: D,
  "input-calculator__helper": "elo-input-calculator__helper",
  input__error: L,
  "input-calculator__error": "elo-input-calculator__error",
  "input__hover-text": "elo-input__hover-text",
  "input-calculator__hover-text": "elo-input-calculator__hover-text",
  "input__field-wrapper": "elo-input__field-wrapper",
  input__wrapper: j,
  "input-calculator__field-wrapper": "elo-input-calculator__field-wrapper",
  "input-calculator__wrapper": "elo-input-calculator__wrapper",
  "input-calculator__tooltip": "elo-input-calculator__tooltip"
}, J = z(
  ({
    label: u,
    labelProminence: i = "low",
    helperText: _,
    errorText: r,
    variant: t = "default",
    hoverText: c,
    formTooltipTitle: a,
    formTooltipContent: h,
    wrapperClass: b,
    ...p
  }, x) => {
    const m = r && r !== "";
    return /* @__PURE__ */ s(
      "label",
      {
        className: n(l.input, b, {
          [l["input-calculator"]]: t === "calculator",
          [l["input__disable-events"]]: h && a
        }),
        "data-error": m,
        children: [
          u && /* @__PURE__ */ s(
            d,
            {
              type: "paragraph",
              size: i === "high" ? "mediumBold" : "medium",
              extraClass: n(l.input__label, {
                [l["input-calculator__label"]]: t === "calculator"
              }),
              children: [
                /* @__PURE__ */ e(
                  "span",
                  {
                    "data-disabled": p.disabled,
                    className: n(
                      i === "high" ? l["input__label--high"] : l["input__label--low"],
                      {
                        [l["input-calculator__label--high"]]: t === "calculator" && i === "high",
                        [l["input-calculator__label--low"]]: t === "calculator" && i === "low"
                      }
                    ),
                    children: u
                  }
                ),
                " ",
                p.required ? /* @__PURE__ */ e(
                  "span",
                  {
                    "aria-label": "Required",
                    className: l["input__label--required"],
                    children: "*"
                  }
                ) : null
              ]
            }
          ),
          /* @__PURE__ */ s("div", { className: l.input__wrapper, children: [
            /* @__PURE__ */ s("div", { className: l["input__field-wrapper"], children: [
              /* @__PURE__ */ e(
                "input",
                {
                  ref: x,
                  ...p,
                  className: n(
                    l.input__field,
                    "elo-text__paragraph--medium",
                    {
                      [l["input-calculator__field"]]: t === "calculator"
                    }
                  ),
                  "data-error": m
                }
              ),
              c && /* @__PURE__ */ e(
                d,
                {
                  size: "small",
                  type: "paragraph",
                  extraClass: l["input__hover-text"],
                  "data-disabled": p.disabled,
                  children: c
                }
              )
            ] }),
            a && h && /* @__PURE__ */ e(
              H,
              {
                title: a,
                className: l["input-calculator__tooltip"],
                children: h
              }
            )
          ] }),
          r ? /* @__PURE__ */ e(
            d,
            {
              size: "small",
              type: "paragraph",
              extraClass: l.input__error,
              children: r
            }
          ) : _ ? /* @__PURE__ */ e(
            d,
            {
              size: "small",
              type: "paragraph",
              extraClass: l.input__helper,
              "data-disabled": p.disabled,
              children: _
            }
          ) : null
        ]
      }
    );
  }
), B = "elo-tooltip", F = "elo-tooltip__title", K = "elo-tooltip__content", $ = "elo-tooltip__text", w = {
  tooltip: B,
  tooltip__title: F,
  tooltip__content: K,
  tooltip__text: $
}, O = g.forwardRef(
  ({ title: u, children: i, ..._ }, r) => {
    const t = n(w.tooltip, _.className);
    return /* @__PURE__ */ s("div", { ref: r, ..._, className: t, children: [
      /* @__PURE__ */ e("div", { className: w.tooltip__title, children: /* @__PURE__ */ e(d, { type: "label", size: "small", children: u }) }),
      /* @__PURE__ */ e("div", { className: w.tooltip__content, children: /* @__PURE__ */ e(d, { type: "paragraph", size: "small", extraClass: w.tooltip__text, children: i }) })
    ] });
  }
);
export {
  H as F,
  J as I,
  O as T
};
